import { render } from "./UploadModal.vue?vue&type=template&id=1059eaec&scoped=true&ts=true"
import script from "./UploadModal.vue?vue&type=script&lang=ts"
export * from "./UploadModal.vue?vue&type=script&lang=ts"

import "./UploadModal.vue?vue&type=style&index=0&id=1059eaec&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1059eaec"]])

export default __exports__